import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import arrow from 'images/three_d_studio/empty_state/arrow.webp'

function EmptyState() {
  const t = useTranslation()

  return (
    <div className="empty-state">
      <p className="empty-state__text cgt-body-base-semibold">
        {t('sidebar.library.emptyState.text')}
      </p>
      <img
        className="empty-state__arrow"
        src={arrow}
        alt=""
        aria-hidden="true"
        width="58"
        height="22"
      />
    </div>
  )
}

export default memo(EmptyState)
